document.addEventListener('DOMContentLoaded', function () {

  // ── INTRO ──
  var intro = document.getElementById('intro');
  var main = document.getElementById('main');

  function dismissIntro() {
    if (!intro || !main) return;
    intro.classList.add('hidden');
    main.classList.add('visible');
    sessionStorage.setItem('goji-intro-seen', '1');
  }

  if (intro && main) {
    if (sessionStorage.getItem('goji-intro-seen')) {
      intro.style.display = 'none';
      main.classList.add('visible');
    } else {
      var enterBtn = document.getElementById('intro-enter');
      if (enterBtn) enterBtn.addEventListener('click', dismissIntro);
    }
  } else if (main) {
    main.classList.add('visible');
  }

  // ── OVERLAY ──
  var overlay = document.getElementById('overlay');
  function openOverlay() { if (overlay) overlay.classList.add('on'); }
  function closeOverlay() { if (overlay) overlay.classList.remove('on'); }
  if (overlay) {
    overlay.addEventListener('click', function () {
      closeCartDrawer();
      closeSearchDrawer();
      closeMobileNav();
    });
  }

  // ── CART DRAWER ──
  var cartDrawer = document.getElementById('cart-drawer');
  var cartOpen = document.getElementById('cart-open');
  var cartClose = document.getElementById('cart-close');

  function openCartDrawer() {
    if (cartDrawer) {
      cartDrawer.classList.add('open');
      cartDrawer.setAttribute('aria-hidden', 'false');
    }
    openOverlay();
  }

  function closeCartDrawer() {
    if (cartDrawer) {
      cartDrawer.classList.remove('open');
      cartDrawer.setAttribute('aria-hidden', 'true');
    }
    closeOverlay();
  }

  function refreshCartDrawer(callback) {
    fetch('/cart.js')
      .then(function(r) { return r.json(); })
      .then(function(cart) {
        var countEl = document.getElementById('cart-count');
        if (countEl) countEl.textContent = cart.item_count > 0 ? cart.item_count : '';

        var itemsEl = document.getElementById('cart-items');
        var footerEl = document.querySelector('.cart-drawer-footer');

        if (!itemsEl) return;

        if (cart.item_count === 0) {
          itemsEl.innerHTML = '<p class="cart-empty">Your bag is empty.</p>';
          if (footerEl) footerEl.style.display = 'none';
        } else {
          var html = '';
          cart.items.forEach(function(item, index) {
            var imgHtml = item.image
              ? '<img src="' + item.image + '" alt="' + item.title + '">'
              : '';
            var variantHtml = item.variant_title && item.variant_title !== 'Default Title'
              ? '<p class="cart-item-variant">' + item.variant_title + '</p>'
              : '';
            html += '<div class="cart-item" data-key="' + item.key + '">'
              + '<div class="cart-item-img">' + imgHtml + '</div>'
              + '<div class="cart-item-details">'
              + '<p class="cart-item-name">' + item.product_title + '</p>'
              + variantHtml
              + '<p class="cart-item-price">' + formatMoney(item.line_price) + '</p>'
              + '<div class="cart-qty">'
              + '<button class="qty-btn qty-minus" data-line="' + (index + 1) + '" data-qty="' + (item.quantity - 1) + '" aria-label="Decrease">−</button>'
              + '<span class="qty-val">' + item.quantity + '</span>'
              + '<button class="qty-btn qty-plus" data-line="' + (index + 1) + '" data-qty="' + (item.quantity + 1) + '" aria-label="Increase">+</button>'
              + '</div>'
              + '<button class="cart-item-remove" data-line="' + (index + 1) + '" data-qty="0">Remove</button>'
              + '</div>'
              + '</div>';
          });
          itemsEl.innerHTML = html;

          if (footerEl) {
            footerEl.style.display = '';
            var subtotalEl = footerEl.querySelector('.cart-subtotal-val');
            if (subtotalEl) subtotalEl.textContent = formatMoney(cart.total_price);
          } else {
            var newFooter = document.createElement('div');
            newFooter.className = 'cart-drawer-footer';
            newFooter.innerHTML = '<div class="cart-subtotal"><span class="cart-subtotal-label">Subtotal</span><span class="cart-subtotal-val">' + formatMoney(cart.total_price) + '</span></div>'
              + '<p class="cart-shipping-note">Shipping calculated at checkout</p>'
              + '<a href="/checkout" class="cart-checkout-btn">Checkout</a>';
            cartDrawer.querySelector('.cart-drawer-inner').appendChild(newFooter);
          }
        }

        if (callback) callback();
      });
  }

  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  window.openCart = function() {
    refreshCartDrawer(function() { openCartDrawer(); });
  };

  if (cartOpen) {
    cartOpen.addEventListener('click', function() {
      refreshCartDrawer(function() { openCartDrawer(); });
    });
  }
  if (cartClose) cartClose.addEventListener('click', closeCartDrawer);

  // ── CART QTY + REMOVE (event delegation) ──
  document.addEventListener('click', function(e) {
    var btn = e.target.closest('.qty-btn, .cart-item-remove');
    if (!btn) return;
    var line = parseInt(btn.dataset.line);
    var qty = parseInt(btn.dataset.qty);
    if (!line || isNaN(qty)) return;

    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ line: line, quantity: qty })
    })
    .then(function(r) { return r.json(); })
    .then(function() { refreshCartDrawer(null); });
  });

  // ── SEARCH DRAWER ──
  var searchDrawer = document.getElementById('search-drawer');
  var searchOpen = document.getElementById('search-open');
  var searchClose = document.getElementById('search-close');
  var searchInput = searchDrawer ? searchDrawer.querySelector('.search-input') : null;

  function openSearchDrawer() {
    if (searchDrawer) { searchDrawer.classList.add('open'); searchDrawer.setAttribute('aria-hidden', 'false'); }
    if (searchInput) setTimeout(function () { searchInput.focus(); }, 100);
    openOverlay();
  }

  function closeSearchDrawer() {
    if (searchDrawer) { searchDrawer.classList.remove('open'); searchDrawer.setAttribute('aria-hidden', 'true'); }
    closeOverlay();
  }

  if (searchOpen) searchOpen.addEventListener('click', openSearchDrawer);
  if (searchClose) searchClose.addEventListener('click', closeSearchDrawer);

  // ── MOBILE NAV ──
  var mobileNav = document.getElementById('mobile-nav');
  var navOpen = document.getElementById('nav-open');
  var navClose = document.getElementById('nav-close');

  function openMobileNav() {
    if (mobileNav) { mobileNav.classList.add('open'); mobileNav.setAttribute('aria-hidden', 'false'); }
    openOverlay();
  }

  function closeMobileNav() {
    if (mobileNav) { mobileNav.classList.remove('open'); mobileNav.setAttribute('aria-hidden', 'true'); }
    closeOverlay();
  }

  if (navOpen) navOpen.addEventListener('click', openMobileNav);
  if (navClose) navClose.addEventListener('click', closeMobileNav);

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { closeCartDrawer(); closeSearchDrawer(); closeMobileNav(); }
  });

  // ── INITIAL CART COUNT ──
  fetch('/cart.js')
    .then(function(r) { return r.json(); })
    .then(function(cart) {
      var countEl = document.getElementById('cart-count');
      if (countEl) countEl.textContent = cart.item_count > 0 ? cart.item_count : '';
    });

});
